interface RequestParams {
	[key: string]: string
}

export const parseSearchQuery = (searchString: string): RequestParams => {
	const result: RequestParams = {};
	const entriesIterator = new URLSearchParams(searchString).entries();
	const entries = Array.from(entriesIterator);

	entries.forEach((param) => {
			result[param[0]] = param[1];
		}
	);

	return result;
};
